import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appValidateDecimals]'
})
export class ValidateDecimalsDirective {
  private previousValue: string = '';

  constructor(private el: ElementRef<HTMLInputElement>) {
    // Inicializar el valor del input con "$" si está vacío
    const initialValue = this.el.nativeElement.value || '';
    this.el.nativeElement.value = this.prefixDollar(initialValue);
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Eliminar todos los caracteres no numéricos excepto el punto decimal
    let currentValue = value.replace(/[^0-9.]/g, '');
    
    // Si el valor no empieza con "1" y el valor anterior no es "+1 ", añadir "1" al inicio
    if (!currentValue.startsWith('$') && this.previousValue !== '$') {
      currentValue = '$' + currentValue;
    }

    const formattedValue = this.prefixDollar(this.formatDecimal(currentValue));

    if (this.el.nativeElement.value !== formattedValue) {
      this.el.nativeElement.value = formattedValue;
    }

    this.previousValue = formattedValue; // Guardar el valor actual para comparaciones futuras
  }

  private formatDecimal(value: string): string {
    if (!value) return '$';

    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) {
      return value;
    }

    const integerPart = value.slice(0, decimalIndex);
    const decimalPart = value.slice(decimalIndex, decimalIndex + 3); // Máximo 2 decimales

    return `${integerPart}${decimalPart}`;
  }

  private prefixDollar(value: string): string {
    if (!value.startsWith('$')) {
      value = '$' + value;
    }
    return value;
  }
}
